import { useEffect, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IS_IFRAME_MODE } from 'config/envVariable';
import * as postMsgEvent from 'config/postMsgEvent';
import { setIsZinesEmbedded, setIsWidgetEmbedded } from 'client/redux/modules/appState';

export default function useSpecificIframeEmbedInitPostMsg(eventType) {
    const dispatch = useDispatch();
    const CHECK_IFRAME_EMBEDDED_EVENTS = useMemo(
        () => ({
            widget: {
                event: postMsgEvent.IS_WIDGET_EMBEDDED,
                action: setIsWidgetEmbedded
            },
            zines: {
                event: postMsgEvent.IS_ZINES_EMBEDDED,
                action: setIsZinesEmbedded
            }
        }),
        []
    );

    const handleMessage = useCallback(
        event => {
            const message = event.data ?? {};
            if (message.event === CHECK_IFRAME_EMBEDDED_EVENTS[eventType]?.event) {
                dispatch(CHECK_IFRAME_EMBEDDED_EVENTS[eventType]?.action());
            }
        },
        [CHECK_IFRAME_EMBEDDED_EVENTS, dispatch, eventType]
    );

    useEffect(() => {
        if (IS_IFRAME_MODE && CHECK_IFRAME_EMBEDDED_EVENTS[eventType]) {
            window.parent.postMessage(
                {
                    event: CHECK_IFRAME_EMBEDDED_EVENTS[eventType]?.event
                },
                '*'
            );
            window.addEventListener('message', handleMessage, false);
            return () => {
                window.removeEventListener('message', handleMessage, false);
            };
        }
    }, [CHECK_IFRAME_EMBEDDED_EVENTS, dispatch, eventType, handleMessage]);
}
